module.exports = __webpack_public_path__ + "img/as.e71c5f5e.svg";